import { BaggageFeesInformationType } from 'types/search/listings';
import { BaggageFeesInformationDetail } from 'components/search/listings/offer/details/baggage-fees-information';
import * as React from 'react';

export const BaggageFeesInformationDetailCard = (baggageFeesInformation: BaggageFeesInformationType) => {
  const details = baggageFeesInformation.details;

  return (
    <>
      {details && (
        <table className="uitk-table experimental-pricing all-b-margin-four" data-test-id="baggage-info-table">
          <tbody className="uitk-table-body">
            {details.map((bagFeesDetail, bagFeesDetailIndex) => (
              <BaggageFeesInformationDetail key={`bag-fee-detail-${bagFeesDetailIndex}`} {...bagFeesDetail} />
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};
